module.exports = __webpack_public_path__ + "static/media/simpsonsquote.98cd9c83.png";